import React, { useMemo } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Counter from 'yet-another-react-lightbox/plugins/counter';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import 'yet-another-react-lightbox/plugins/counter.css';
import { useImageLightboxStore } from '@/stores/useImageLightboxStore';

export const ImageLightbox: React.FC = () => {
  const { isOpen, images, currentIndex, closeLightbox } = useImageLightboxStore();

  const slides = useMemo(
    () =>
      images.map((img) => ({
        src: img.url,
        alt: img.alt,
        ...(img.thumbnailUrl ? { thumbnail: img.thumbnailUrl } : {}),
      })),
    [images]
  );

  if (!isOpen || slides.length === 0) return null;

  return (
    <Lightbox
      open={isOpen}
      close={closeLightbox}
      slides={slides}
      index={currentIndex}
      on={{
        view: ({ index }) => {
          useImageLightboxStore.getState().goToIndex(index);
        },
      }}
      plugins={[Zoom, Thumbnails, Counter]}
      zoom={{
        maxZoomPixelRatio: 5,
        scrollToZoom: true,
      }}
      thumbnails={{
        position: 'bottom',
        width: 60,
        height: 60,
        gap: 8,
        showToggle: false,
      }}
      carousel={{
        finite: false,
      }}
      animation={{
        swipe: 250,
      }}
      controller={{
        closeOnBackdropClick: true,
      }}
      styles={{
        container: { backgroundColor: 'rgba(0, 0, 0, 0.92)' },
      }}
    />
  );
};
